const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import ModuleManager from "../../../../framework/core/module_manager";

@ccclass
export default class DialogLeaveView extends ViewBase {

    @property(cc.Label)
    label_content: cc.Label = null

    @property(cc.Toggle)
    toggle: cc.Toggle = null


    showPanel(content: string, isCheck?: boolean){
        this.label_content.string = content
        this.toggle.isChecked = isCheck || false
    }
}